module.exports = __webpack_public_path__ + "img/no_company.bda1de07.png";